import React from "react";
import ServiceCollection from "src/services/ServiceCollection";
import TPEAction from "src/models/common/TPEAction";
import CONSTANTS from "src/utils/constants";
import {ACTIONS} from 'src/services/calculation-builder/JESettingsReducer';
import {DryRunResponse} from "src/models/calculation-builder/DryRunResponse";
import WebSocketApi from "src/services/WebSocketApi";

interface WebSocketMessage {
    message: string;
    messageType: string;
    status: string;
}

export function setupWebSocketEvents(services: ServiceCollection, dispatch: React.Dispatch<TPEAction>) {
    const listener = async (messageData: string) => {
        try {
            const webSocketMessage: WebSocketMessage = JSON.parse(messageData);

            if (webSocketMessage.messageType === CONSTANTS.WEB_SOCKET_API_ROUTES.GENERATE_REVIEW_JOURNALS) {
                if (webSocketMessage.status === CONSTANTS.GENERATE_REVIEW_JOURNAL_STATUS.FAILED) {
                    dispatch(ACTIONS.SET_GENERATE_REVIEW_JOURNALS_PAYLOAD.withPayload(null));
                    dispatch(ACTIONS.SET_GENERATE_REVIEW_JOURNALS_STATUS.withPayload(CONSTANTS.GENERATE_REVIEW_JOURNAL_STATUS.FAILED));
                    services.messageService.showErrorBanner(webSocketMessage.message);
                } else if (webSocketMessage.status === CONSTANTS.GENERATE_REVIEW_JOURNAL_STATUS.VALIDATION_FAILED) {
                    dispatch(ACTIONS.SET_GENERATE_REVIEW_JOURNALS_PAYLOAD.withPayload(null));
                    dispatch(ACTIONS.SET_GENERATE_REVIEW_JOURNALS_STATUS.withPayload(CONSTANTS.GENERATE_REVIEW_JOURNAL_STATUS.VALIDATION_FAILED));

                    const dryRunResponse = await processDryRunResponse(webSocketMessage, services, dispatch)
                    services.journalsService.convertLineErrorsToMap(dryRunResponse.journals);
                    displayValidationErrors(dryRunResponse, dispatch);
                } else if (webSocketMessage.status === CONSTANTS.GENERATE_REVIEW_JOURNAL_STATUS.SUCCEEDED) {
                    await processDryRunResponse(webSocketMessage, services, dispatch)
                    dispatch(ACTIONS.SET_GENERATE_REVIEW_JOURNALS_STATUS.withPayload(CONSTANTS.GENERATE_REVIEW_JOURNAL_STATUS.SUCCEEDED));
                }
            }
        } catch (error) {
            services.messageService.showErrorBanner('Failed to generate review journals');
            console.error('WebSocket message parsing error:', error);
        }
    };

    const errorHandler = (x: any) => {
        setTimeout(() => {
            dispatch(ACTIONS.RESET_WORKFLOW);
            dispatch(ACTIONS.SET_GENERATE_REVIEW_JOURNALS_STATUS.withPayload(''));
        }, 500);
    }

    services.atpWebSocketApiService.addListener(listener);
    services.atpWebSocketApiService.addKeyListener(WebSocketApi.ConnectionEvent.ON_ERROR, errorHandler);
    return { listener, errorHandler };
}

async function processDryRunResponse(webSocketMessage: WebSocketMessage, services: ServiceCollection, dispatch: React.Dispatch<TPEAction>): Promise<DryRunResponse> {
    const response = await fetch(webSocketMessage.message);
    const dryRunResponse = await response.json() as DryRunResponse;

    services.journalsService.convertJournalFieldsToDisplayFormat(dryRunResponse.journals);
    dispatch(ACTIONS.SET_REVIEW_JOURNALS.withPayload(dryRunResponse.journals));
    return dryRunResponse;
}

function displayValidationErrors(dryRunResult: DryRunResponse, dispatch: React.Dispatch<TPEAction>) {
    const localErrorsCount = dryRunResult.journals.flatMap(j => j.journalLines).filter(line => line.errors?.size > 0).length;
    
    dispatch(ACTIONS.SET_JOURNALS_ARE_VALID_IN_IPE.withPayload(dryRunResult.isValid));
    dispatch(ACTIONS.SET_VALIDATION_ERRORS.withPayload([`${localErrorsCount} error${localErrorsCount !== 1 ? "s" : ""} found. Please fix errors and try again.`]));
}
